export const measurementTypeTranslationMap = {
  distanceMeasurement: 'option.measurementOverlay.distanceMeasurement',
  perimeterMeasurement: 'option.measurementOverlay.perimeterMeasurement',
  areaMeasurement: 'option.measurementOverlay.areaMeasurement',
  rectangularAreaMeasurement: 'option.measurementOverlay.areaMeasurement',
  cloudyRectangularAreaMeasurement: 'option.measurementOverlay.areaMeasurement',
  ellipseMeasurement: 'option.measurementOverlay.areaMeasurement',
  arcMeasurement: 'option.measurementOverlay.arcMeasurement',
};